import Image from 'next/image';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import s from './Slider.module.css';
import 'swiper/css';
import { SliderItem } from '@/types/model';
import useIsMobile from '@/hooks/use-is-mobile';
import { ImageLoader } from '@/lib/imageLoader';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

const Slider = ({ items }: { items: SliderItem[] }) => {
  const isMobile = useIsMobile();
  const t = useTranslations('slider');

  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      <Swiper
        className={s.container__swiper}
        slidesPerView={isMobile ? 1 : 3}
        centeredSlides
        spaceBetween={15}
        loop>
        {items.map((item, index) => {
          const url = isMobile ? item.imageMobile?.url : item.imageDesktop?.url;
          const description = item.description;
          return (
            <SwiperSlide className={s.container__swiper__slide} key={index}>
              {({ isActive }) => (
                <>
                  {url && (
                    <Image
                      src={ImageLoader({ src: url })}
                      alt={t('representativeImage')}
                      width={isMobile ? 340 : 1010}
                      height={isMobile ? 265 : 654}
                      sizes={isMobile ? '340px' : '1010px'}
                      quality={65}
                    />
                  )}
                  {isActive && (
                    <motion.h3
                      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
                      className={s.container__swiper__slide__title}>
                      {description}
                    </motion.h3>
                  )}
                </>
              )}
            </SwiperSlide>
          );
        })}
        <SlideButtons />
      </Swiper>
    </motion.div>
  );
};

function SlideButtons() {
  const swiper = useSwiper();
  const t = useTranslations('slider');

  return (
    <div className={s.swiper_buttons}>
      <button
        className={s.swiper_buttons__prev}
        onClick={() => swiper.slidePrev()}
        aria-label={t('prevSlide')}>
        <ReactSVG src="/icons/flecha-boton.svg" beforeInjection={hideDecorativeSvg} />
      </button>
      <button onClick={() => swiper.slideNext()} aria-label={t('nextSlide')}>
        <ReactSVG src="/icons/flecha-boton.svg" beforeInjection={hideDecorativeSvg} />
      </button>
    </div>
  );
}

export default Slider;
